
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';

    class EditUserExpressInfo {
        id: number;
        returnOrderNumber: string;
        isProcessReturn: boolean;
        isReturn: boolean;
        processReturnReMark: string;
    }
    @Component
    export default class EditReturnUserExpressInfoModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        isReadOnly = false;
        imgUrl: string = '';
        imgUploadUrl: string = '';
        orderNumber: string = "";
        EditModule: EditUserExpressInfo = new EditUserExpressInfo();

        created() {

        }
        cancel() {
            (this.$refs.userexpressinfoForm as any).resetFields();
            this.$emit('input', false);
        }
        save() {
            (this.$refs.userexpressinfoForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    await this.$store.dispatch({
                        type: 'expressuserinfo/editReturn',
                        data: this.EditModule
                    });
                    (this.$refs.userexpressinfoForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }

        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                (this.$refs.userexpressinfoForm as any).resetFields();
                var data = this.$store.state.expressuserinfo.userExpressInfo;
                this.EditModule.isReturn = data.isReturn;
                this.EditModule.isProcessReturn = data.isReturnProcess;
                this.EditModule.returnOrderNumber = data.returnOrderNumber;
                this.EditModule.id = data.id;
                this.EditModule.processReturnReMark = data.processReturnReMark;
            }
        }
    }

